import { localize } from '../i18n';

import { needsAndroid105Update } from './release105Access';
import { compareVersions } from './version';

const APP_RUNTIME_INFO_KEY = 'pill_reminder_app_runtime_info';
const MIN_VIBRATION_ALERT_VERSION = '1.0.5';

export function readAlertRuntimeInfo() {
    if (typeof window === 'undefined') return null;
    try {
        const runtimeInfo = JSON.parse(localStorage.getItem(APP_RUNTIME_INFO_KEY) || '{}') || {};
        const params = new URLSearchParams(window.location.search || '');
        const devPlatform = params.get('platform');
        const canUseDevPlatform = params.has('dev') || window.location.hostname === 'localhost';
        if (canUseDevPlatform && ['ios', 'android'].includes(devPlatform)) {
            return {
                ...runtimeInfo,
                platform: devPlatform,
                appVersion: runtimeInfo.appVersion || '1.0.5',
                runtimeVersion: runtimeInfo.runtimeVersion || '1.0.5',
            };
        }
        return runtimeInfo || null;
    } catch (_) {
        return null;
    }
}

export function readNativePlatform(runtimeInfo = readAlertRuntimeInfo()) {
    if (typeof window === 'undefined') return null;
    if (window.NATIVE_PLATFORM) return window.NATIVE_PLATFORM;
    return runtimeInfo?.platform || null;
}

export function supportsVibrationAlert(runtimeInfo = readAlertRuntimeInfo(), nativePlatform = readNativePlatform(runtimeInfo)) {
    const nativeVersion = runtimeInfo?.appVersion || runtimeInfo?.runtimeVersion || '';
    return nativePlatform === 'android'
        && nativeVersion
        && compareVersions(nativeVersion, MIN_VIBRATION_ALERT_VERSION) >= 0;
}

export function getAlertMethodSettingSubtitle(runtimeInfo = readAlertRuntimeInfo(), nativePlatform = readNativePlatform(runtimeInfo)) {
    return (supportsVibrationAlert(runtimeInfo, nativePlatform) || needsAndroid105Update(runtimeInfo))
        ? localize('푸시·진동·벨소리 알림을 바꿔요')
        : localize('푸시·벨소리 알림을 바꿔요');
}


export function normalizeAlarmVolume(alarmVolume, fallback = 80) {
    const volume = Number(alarmVolume);
    if (!Number.isFinite(volume) || volume <= 0) return fallback;
    return Math.min(100, Math.round(volume));
}
